import {
  AnalyticsIcon
} from "@/components/icons";
import React, { FC } from "react";
import { BiCog } from "react-icons/bi";
import { LuCreditCard } from "react-icons/lu";
import { IconLanguage } from "@tabler/icons-react";
import { SideBarRouteOption, ISidebarProps } from "@/types";
import { FaGear, FaMoneyCheckDollar } from "react-icons/fa6";
import { GiHealthCapsule, GiTribunalJury, GiWinterGloves } from "react-icons/gi";

// Wrapper components to handle isActive prop for react-icons
const CogIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(BiCog, props);

const CreditCardIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(LuCreditCard, props);

const GearIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(FaGear, props);

const MoneyCheckDollarIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(FaMoneyCheckDollar, props);

const HealthCapsuleIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(GiHealthCapsule, props);

const TribunalJuryIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(GiTribunalJury, props);

const WinterGlovesIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(GiWinterGloves, props);

const licencingAdminRoutes: SideBarRouteOption[] = [
  {
    name: "Analytics",
    path: "/licencing-admin",
    icon: AnalyticsIcon,
  },
  /*{
    name: "Location Conf.",
    path: "/licencing-admin/locations",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "country",
        path: "/licencing-admin/locations/country",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Province Configuration",
        path: "/licencing-admin/locations/province",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "District Configuration",
        path: "/licencing-admin/locations/district",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Sector Configuration",
        path: "/licencing-admin/locations/sector",
        icon: MoneyCheckDollarIcon,
      },
    ],
  },*/
  {
    name: "Secondary Ed.",
    path: "/licencing-admin/secondary-education",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "document Title",
        path: "/licencing-admin/secondary-education/document-title",
        icon: MoneyCheckDollarIcon,
      },
    ],
  },
  {
    name: "Post Secondary",
    path: "/licencing-admin/post-secondary-education",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "Exit Award Settings",
        path: "/licencing-admin/post-secondary-education/exitaward",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Professions Category",
        path: "/licencing-admin/post-secondary-education/professions-category",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Professions Credential",
        path: "/licencing-admin/post-secondary-education/professions-credential",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Academic Degree Program",
        path: "/licencing-admin/post-secondary-education/academic-degree-program",
        icon: MoneyCheckDollarIcon,
      },
    ],
  },
  {
    name: "Control Panel",
    path: "/licencing-admin/control-panel",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "Education Institutions",
        path: "/licencing-admin/control-panel/education-institutions",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Internship Sites",
        path: "/licencing-admin/control-panel/internship-sites",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Councils Configuration",
        path: "/licencing-admin/control-panel/councils-configuration",
        icon: TribunalJuryIcon
      },
      {
        name: "Bank Configuration",
        path: "/licencing-admin/control-panel/bank-configuration",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Irembo Payment Configuration",
        path: "/licencing-admin/control-panel/irembo-configuration",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Services Configuration",
        path: "/licencing-admin/control-panel/services-configuration",
        icon: GearIcon,
      },
      {
        name: "Study Level Configuration",
        path: "/licencing-admin/control-panel/study-level-configuration",
        icon: GearIcon
      },
      {
        name: "Licence Fee Configuration",
        path: "/licencing-admin/control-panel/licence-fee-configuration",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Exam Configuration",
        path: "/licencing-admin/control-panel/exam-configuration",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Exam Center Management",
        path: "/licencing-admin/control-panel/exam-center-management",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Fines Configuration",
        path: "/licencing-admin/control-panel/fines-configuration", 
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Language Management",
        path: "/licencing-admin/control-panel/language-management",
        icon: IconLanguage,
      },
      {
        name: "SMTP Configuration",
        path: "/licencing-admin/control-panel/smtp-configuration",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Invigilator Shifts",
        path: "/licencing-admin/control-panel/invigilator-shifts",
        icon: WinterGlovesIcon,
      },
      {
        name: "Manual Approvals",
        path: "/licencing-admin/control-panel/manual-approvals",
        icon: WinterGlovesIcon,
      },
      {
        name: "Audit Logs",
        path: "/licencing-admin/control-panel/audit-logs",
        icon: GearIcon,
      },
    ],
  },
  {
    name: "Council Payments",
    path: "/licencing-admin/council-payments",
    icon: CreditCardIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "All Payments",
        path: "/licencing-admin/council-payments",
        icon: CreditCardIcon,
      },
      {
        name: "Pending Payments",
        path: "/licencing-admin/council-payments/pending",
        icon: CreditCardIcon,
      },
    ],
  },
  {
    name: "System Settings",
    path: "/licencing-admin/system-settings",
    icon: CogIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "Users Configurations",
        path: "/licencing-admin/system-settings/users",
        icon: WinterGlovesIcon,
      },
      {
        name: "Users Roles",
        path: "/licencing-admin/system-settings/roles",
        icon: HealthCapsuleIcon,
      },
      {
        name: "Approval Structure Configuration",
        path: "/licencing-admin/system-settings/approval-structure",
        icon: HealthCapsuleIcon,
      },
      {
        name: "Bulk Import Users",
        path: "/licencing-admin/system-settings/bulk-import-users",
        icon: WinterGlovesIcon,
      },
    ],
  },
];

export default licencingAdminRoutes;